import { LocalesTree } from '@platform/front-types';

const startPage: LocalesTree = {
    title: 'Collection and processing of assistant requests',
    productDescription:
        'Here assistants and volunteers apply for inclusion in the register. Our administrators will process the application within 3 days',
    logoAlt: 'RRC logo',
};

export default startPage;
